import { render, staticRenderFns } from "./CultureShow.vue?vue&type=template&id=3a4c4626&scoped=true"
import script from "./CultureShow.vue?vue&type=script&lang=js"
export * from "./CultureShow.vue?vue&type=script&lang=js"
import style0 from "./CultureShow.vue?vue&type=style&index=0&id=3a4c4626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c4626",
  null
  
)

export default component.exports